import { createI18n } from 'vue-i18n'
import zhCN from './locales/zh-CN'
import enUS from './locales/en-US'
import jaJP from './locales/ja-JP'

export const LOCALE_KEY = 'app-locale'

export type AppLocale = 'zh-CN' | 'en-US' | 'ja-JP'

const messages = {
  'zh-CN': zhCN,
  'en-US': enUS,
  'ja-JP': jaJP,
}

export function normalizeLocale(raw: string | null | undefined): AppLocale {
  if (!raw) return 'zh-CN'
  if (raw === 'en' || raw === 'en-US') return 'en-US'
  if (raw === 'ja' || raw === 'ja-JP') return 'ja-JP'
  if (raw === 'zh-TW') return 'zh-CN'
  return 'zh-CN'
}

export function getStoredLocale(): AppLocale {
  return normalizeLocale(localStorage.getItem(LOCALE_KEY))
}

export function toApiLang(locale: string): string {
  const map: Record<string, string> = {
    'zh-CN': 'zh_CN',
    'zh-TW': 'zh_TW',
    'en-US': 'en_US',
    'en': 'en_US',
    'ja-JP': 'en_US',
    'ja': 'en_US',
  }
  return map[locale] || 'zh_CN'
}

export function getApiLang(): string {
  return toApiLang(getStoredLocale())
}

export function applyDocumentLang(locale: AppLocale) {
  document.documentElement.lang = locale === 'ja-JP' ? 'ja' : locale.startsWith('zh') ? 'zh' : 'en'
}

export const i18n = createI18n({
  legacy: false,
  globalInjection: true,
  locale: getStoredLocale(),
  fallbackLocale: 'zh-CN',
  messages,
})

export function setAppLocale(locale: string) {
  const normalized = normalizeLocale(locale)
  i18n.global.locale.value = normalized
  localStorage.setItem(LOCALE_KEY, normalized)
  applyDocumentLang(normalized)
}

applyDocumentLang(getStoredLocale())
